import { Resort } from "./Resort"
import { BlocksContent } from "@strapi/blocks-react-renderer"
import { Image } from "@t/Image"

type R = Pick<Resort, "short_name" | "id" | "slug" | "nonDisneyWorld" | "is_visible">
export type Tier = {
    level: number
    levelInfo: string
    name: string
}

export enum MEGA_MENU_GROUP {
    SELL = "sell"
}

export type BlockLink = {
    id: number
    link: string
    title: string
    description: string
    icon?: Image
    column: number
}

export type MegaMenu = {
    group: MEGA_MENU_GROUP
    linksTitle: string
    links: BlocksContent
    blockLinks: BlockLink[]
}

export type GeneralData = {
    gradingSystemUrl: string
    resorts: R[]
    tiers: Tier[]
    megaMenu: MegaMenu[]
    defaultSEO: {
        title: string
        description: string
        keywords: string
        content_h1: string
        content: string
        wide_img: {
            data: {
                attributes: {
                    alternativeText: string
                    formats: string
                }
            }
        }
    }
}
